import React from 'react';
import NeoPrismaAcademyLogo from '@/components/branding/NeoPrismaAcademyLogo';
import { useSidebar } from '@/components/ui/sidebar';
export const SidebarHeader = () => {
  const {
    state
  } = useSidebar();
  return <div className="flex items-center justify-between p-4 border-b">
      {state !== "collapsed" && <div className="flex items-center gap-2">
          <NeoPrismaAcademyLogo />
          
        </div>}
      {state === "collapsed" && <div className="flex items-center justify-center w-full">
          <NeoPrismaAcademyLogo />
        </div>}
    </div>;
};